var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle"},[_c('div',{staticClass:"circle_left ab",style:(_vm.renderLeftRate(_vm.progress))}),_c('div',{staticClass:"circle_right ab",style:(_vm.renderRightRate(_vm.progress))})])}
var staticRenderFns = []

export { render, staticRenderFns }